<div *ngIf="show" class="contentLoaderGlobal">
  <div style="display: flex; justify-content: center; align-items: center">
    <!-- <fa-icon icon="spinner" [spin]="true"></fa-icon> -->
    <img src="./assets/img/Simbolodeespera1.gif" alt="" style="width: 150px" />
  </div>
</div>
